<template>

    <div>

        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Accordion</h2>

        <div class="text-center">
            <div class="blocks-action-bar-inline">
                <b-button v-b-tooltip.hover.top title="Add accordion title" variant="primary" class="addChildBlock-btn" size="sm" @click="addToChildArray">
                    +</b-button>
            </div>
        </div>

        <div class="preview-box" :style="{width : previewBoxWidth}">

            <draggable class="bundle-accordion" 
            :data-speed="settingsFromWeebly.settings.speed" :data-active-load="settingsFromWeebly.settings.activeLoad" :data-toggle="settingsFromWeebly.settings.toggle" :data-toggle-icon="settingsFromWeebly.settings.icon"
            :id="'bundle-accordion-'+globalSettings.elementIdWeebly"

            v-model="accordionTitlesArray" 
            ghost-class="ghost-block" 
            handle=".block-drag-handle"
            >
                <AccordionTitle 
                    v-for="(accordionTitle, index) in accordionTitlesArray" :key="index"
                    :titleId="accordionTitle.titleId"
                    :arrayIndex="index"
                    :accordionTitle="accordionTitle"
                />
                
            </draggable>

            <vstyle v-if="!settingsFromWeebly.settings.useCustomFont">
                @import url('https://fonts.googleapis.com/css?family={{settingsFromWeebly.settings.fontGoogleLoad}}');
            </vstyle>

            <vstyle>
                #bundle-accordion-{{globalSettings.elementIdWeebly}} .bundle-accordion-title {
                    background: {{settingsFromWeebly.settings.titleBackground}};
                    border-color: {{settingsFromWeebly.settings.titleBorderColor}};
                }
                #bundle-accordion-{{globalSettings.elementIdWeebly}} .bundle-accordion-title:after {
                    color: {{settingsFromWeebly.settings.iconColor}};
                    font-size: {{settingsFromWeebly.settings.iconSize}}px!important;
                }
                #bundle-accordion-{{globalSettings.elementIdWeebly}} .bundle-accordion-title:hover,
                #bundle-accordion-{{globalSettings.elementIdWeebly}} .bundle-accordion-title.active {
                    background: {{settingsFromWeebly.settings.titleBackgroundHover}};
                }
                #bundle-accordion-{{globalSettings.elementIdWeebly}} .bundle-accordion-title {{settingsFromWeebly.settings.titleTag}} {
                    color: {{settingsFromWeebly.settings.titleColor}}!important;
                    font-size: {{settingsFromWeebly.settings.fontSize}}px!important;
                    text-transform: none !important;
                    letter-spacing: 0px !important;
                    font-family: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontName : settingsFromWeebly.settings.fontFamily}}!important;
                    font-style: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontStyle : settingsFromWeebly.settings.fontStyle}};
                    font-weight: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontWeight : settingsFromWeebly.settings.fontWeight}};
                    letter-spacing: {{settingsFromWeebly.settings.letterSpacing}}px;
                }
                #bundle-accordion-{{globalSettings.elementIdWeebly}} .bundle-accordion-title:hover {{settingsFromWeebly.settings.titleTag}},
                #bundle-accordion-{{globalSettings.elementIdWeebly}} .bundle-accordion-title.active {{settingsFromWeebly.settings.titleTag}} {
                    color: {{settingsFromWeebly.settings.titleColorHover}}!important;
                }

                #bundle-accordion-{{globalSettings.elementIdWeebly}} .bundle-accordion-title:hover:after,
                #bundle-accordion-{{globalSettings.elementIdWeebly}} .bundle-accordion-title.active:after {
                    color: {{settingsFromWeebly.settings.titleColorHover}};
                    color: {{settingsFromWeebly.settings.iconColorHover}};
                }

                #bundle-accordion-{{globalSettings.elementIdWeebly}} .bundle-accordion-content {
                    background: {{settingsFromWeebly.settings.contentBackground}};
                    border-color: {{settingsFromWeebly.settings.titleBorderColor}};
                }
                
            </vstyle>

            <vstyle v-if="globalSettings.elementGuidesOnlyDashboard">
                input.div-like-input-accordion-title {
                    color: {{settingsFromWeebly.settings.titleColor}};
                    font-size: {{settingsFromWeebly.settings.fontSize}}px;
                    font-family: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontName : settingsFromWeebly.settings.fontFamily}}!important;
                    font-style: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontStyle : settingsFromWeebly.settings.fontStyle}};
                    font-weight: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontWeight : settingsFromWeebly.settings.fontWeight}};
                    letter-spacing: {{settingsFromWeebly.settings.letterSpacing}}px;
                }
                .bundle-accordion-title:hover input.div-like-input-accordion-title {
                    color: {{settingsFromWeebly.settings.titleColorHover}};
                }
            </vstyle> 

        </div>

    </div>

</template>

<script>
import AccordionTitle from './elementSettings/accordiontitles/AccordionTitle'
import draggable from 'vuedraggable'

export default {

    name: 'Accordion',

    data () {

        return {
            style: 'style'
        }
    },

    components: {

        AccordionTitle,
        draggable,

        'vstyle': {
            render: function (createElement) {

                return createElement('style', this.$slots.default)
                
            }
        }

    },

    methods: {
        addToChildArray() {

            console.log(this.$store.state.weeblySettings.settings.accordionTitles);

            // this.removeActiveFromBlock()

            this.$store.state.weeblySettings.settings.accordionTitles.push(
                {
                    titleId: 'bundle-accordion-title-'+Math.random().toString(36).substr(2, 16),
                    titleText: 'Click to add your title'
                }
            )

        }
    },

    computed: {

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        },

        // get and set array of titles
        accordionTitlesArray: {
            get() {
                return this.$store.state.weeblySettings.settings.accordionTitles
            },
            set(value) {
                console.log(value)
                // this.$store.commit('updateList', value)
                this.$store.state.weeblySettings.settings.accordionTitles = value
            }
        }

    },
    
    mounted() {
        console.log('from AC', this.$store.state.weeblySettings)
        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';

.addChildBlock-btn {
    font-weight: 700;
    width: 50px;
    height: 50px;
    line-height: 50px;
    border-radius: 50%;
    padding: 0;
    margin: 0;
    font-size: 20px;
    box-shadow: 0 5px 17px fade(@spark_green, 60%);
    transition: all .3s ease-out;
    background: @spark_green;
    border: 0;
    position: relative;
    top: auto;
    left: auto;
    right: auto;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 7px 24px fade(@spark_green, 70%);
        background: fade(@spark_green, 90%)
    }
}

.blocks-action-bar-inline {
    display: inline-block;
    position: relative;
    margin: 10px auto 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/Accordion.vue